/* Musa Shoes – tarjetas de producto en vivo para artículos del blog */
(function () {
  function fmt(cents) {
    return 'L ' + Math.round(cents / 100).toLocaleString('en-US');
  }
  function sized(url, w) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function hide(card) {
    card.style.display = 'none';
    var prev = card.previousElementSibling;
    if (prev && prev.classList.contains('musa-intro')) prev.style.display = 'none';
  }
  function update(card) {
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) { hide(card); return null; }
        if (!r.ok) return null; // error temporal: dejar respaldo
        return r.json();
      })
      .then(function (p) {
        if (!p) return;
        if (!p.available) { hide(card); return; }
        var img = card.querySelector('[data-musa-img]');
        var src = p.featured_image || (p.images && p.images[0]);
        if (img && src) {
          img.src = sized(src, 800);
          img.alt = (p.media && p.media[0] && p.media[0].alt) || (p.title + ' – Musa Shoes Honduras');
        }
        var name = card.querySelector('[data-musa-name]');
        if (name && p.title) name.textContent = p.title.replace(' — ', ' – ');
        var price = card.querySelector('[data-musa-price]');
        if (price) {
          var html = fmt(p.price);
          if (p.compare_at_price && p.compare_at_price > p.price) {
            html += ' <span style="text-decoration:line-through;color:#8a8089;font-size:14px;font-weight:400;margin-left:6px;">' + fmt(p.compare_at_price) + '</span>';
          }
          price.innerHTML = html;
        }
        card.setAttribute('data-live', 'ok');
      })
      .catch(function () { /* mantener respaldo */ });
  }
  function init() {
    var cards = document.querySelectorAll('[data-product-handle]');
    for (var i = 0; i < cards.length; i++) update(cards[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
